
































































































import ListCard, { ListCardType } from '@/components/ListCard.vue'
import JumpLinks from '@/components/PropertyJumpLinks.vue'
import { jumpLinksService } from '@/services'
import { Page } from '@/types/enums'
import { JumpLink } from '@/types/JumpLinksType'
import { formatCurrency, formatLandArea } from '@/utils'
import Vue from 'vue'

export default Vue.extend({
    name: 'TenantDetail',
    components:{JumpLinks,ListCard},
    data() {
        return {
            tenant:{} as any,
            jumpLinkData: [] as JumpLink[],
            staticJumpLinks: [] as any[],
            redirectionPage: 'tenant',
            leasesTableHeaders: [
                { text: 'Lease Id', value: 'leaseId' },
                { text: 'Property Id', value: 'propertyId' },
                { text: 'Unit', value: 'unit' },
                { text: 'Rentable Area', value: 'rentableArea' },
                { text: 'Monthly Rent', value: 'leaseMonthlyRent' },
                { text: 'Annual Rent Amount', value: 'leaseAnnualRent' },
                { text: 'Term in Years', value: 'termsInYears' },
                { text: 'LCD', value: 'leaseContractDate' },
                { text: 'LED', value: 'leaseExpiryDate' },
                { text: 'Leasing Rep', value: 'leasingManager' }
            ],
            page: Page.TENANT
        }
    },
    mounted() {
        this.getTenant()
        this.generateJumpLinkData()
    },
    methods: {
        async getTenant() {
            const tenantID = this.$route.params.tenantID

            const res = await this.axios.get(`/Tenant/GetTenant/${tenantID}`)

            this.tenant = res.data
        },
        async generateJumpLinkData(){
            this.jumpLinkData = await jumpLinksService.getJumpLinks(Page.TENANT) ?? []
        },
        formatCurrency,
        formatLandArea
    },
    computed:{
        cardLeft():ListCardType {
            return [
                {
                    label: 'Tenant Name',
                    value: this.tenant.tenantName,
                    method:'quickFilter',
                    name:'Tenant Name'
                },
                {
                    label: 'Tenant ID',
                    value: this.tenant.tenantId
                },
                {
                    label: 'Parent Name',
                    value: this.tenant.parentName,
                    method:'quickFilter',
                    name:'Parent Name'
                },
                {
                    label: 'Parent ID',
                    value: this.tenant.parentId,
                    method:'quickFilter',
                    name:'Parent ID'
                },
                {
                    label: 'Billing Name',
                    value: this.tenant.billingName,
                    method:'quickFilter',
                    name:'Billing Name'
                },
                {
                    label: 'Billing Address',
                    value: this.tenant.billingAddress
                },
                {
                    label: 'Billing City',
                    value: this.tenant.billingCity,
                    method: 'quickFilter',
                    name: 'Billing City'
                },
                {
                    label: 'Billing Postal Code',
                    value: this.tenant.billingPostalCode
                },
                {
                    label: 'Billing State',
                    value: this.tenant.billingState,
                    method: 'quickFilter',
                    name: 'Billing State'
                },
                {
                    label: 'Email',
                    value: this.tenant.email
                },
            ]
        },
        cardCenter(): ListCardType {
            return [
                {
                    label: 'Property ID',
                    value: this.tenant.property?.propertyId,
                    method: 'quickLink',
                    name: 'property'
                },
                {
                    label: 'Business Unit',
                    value: this.tenant.property?.businessUnit,
                },
                {
                    label: 'Property Name',
                    value: this.tenant.property?.propertyName,
                },
                {
                    label: 'Property Address',
                    value: this.tenant.property?.address,
                },
                {
                    label: 'City',
                    value: this.tenant.property?.city,
                    method:'quickFilter',
                    name:'City'
                },
                {
                    label: 'Postal Code',
                    value: this.tenant.property?.postalCode,
                },
                {
                    label: 'State',
                    value: this.tenant.property?.state,
                    method:'quickFilter',
                    name:'State'
                },
                {
                    label: 'Asset Class',
                    value: this.tenant.property?.assetClass,
                    method:'quickFilter',
                    name:'Asset Class',
                },
                {
                    label: 'Region',
                    value: this.tenant.property?.region,
                    method:'quickFilter',
                    name:'Region'
                },
                {
                    label: 'Property Manager',
                    value: this.tenant.property?.contacts.find( (contact:any) => contact.roleName === 'Property Manager')?.fullName,
                },
                {
                    label: 'Leasing Manager',
                    value: this.tenant.property?.contacts.find( (contact:any) => contact.roleName === 'Leasing Manager')?.fullName,
                },
            ]
        },
        cardRight(): ListCardType  {
            return [
                {
                    label: 'AR30',
                    value: this.tenant.ar30,
                    type:'number'
                },
                {
                    label: 'AR60',
                    value: this.tenant.ar60,
                    type:'number'
                },
                {
                    label: 'AR90',
                    value: this.tenant.ar90,
                    type:'number'
                },
                {
                    label: 'AR120',
                    value: this.tenant.ar120,
                    type:'number'
                },
                {
                    label: 'AR Total',
                    value: this.tenant.arTotal,
                    type:'number'
                },
                {
                    label: 'Security Deposit',
                    value: this.tenant.securityDeposit,
                    type:'number'
                },
            ]
        }
    }
})
